export var AVM2LoadLibrariesFlags;
(function (AVM2LoadLibrariesFlags) {
    AVM2LoadLibrariesFlags[AVM2LoadLibrariesFlags["Builtin"] = 1] = "Builtin";
    AVM2LoadLibrariesFlags[AVM2LoadLibrariesFlags["Playerglobal"] = 2] = "Playerglobal";
    AVM2LoadLibrariesFlags[AVM2LoadLibrariesFlags["Shell"] = 4] = "Shell";
})(AVM2LoadLibrariesFlags || (AVM2LoadLibrariesFlags = {}));
